import React from "react";
import { Input, Button, Form } from "antd";
import clsx from "clsx";

import styles from "./client-form.module.css";
import { NewClientValue } from "../../data-types/client-type";
const { ["wrapper"]: wrapperClassName } = styles as any;

type ClientFormProps = {
  onSave: (arg0: NewClientValue) => void;
  onCancel: Function;
  className?: string;
};

export const ClientForm: React.FC<ClientFormProps> = ({ onSave, onCancel, className = "" }) => {
  return (
    <div className={clsx(wrapperClassName, className)}>
      <Form layout="inline" onFinish={(values) => onSave(values)}>
        <Form.Item name="name">
          <Input style={{ width: 300 }} placeholder="Client name" name="clientName" />
        </Form.Item>
        <Form.Item style={{ marginTop: 5 }}>
          <Button style={{ marginRight: 5 }} type="primary" htmlType="submit">
            Save
          </Button>
          <Button onClick={() => onCancel()}>Cancel</Button>
        </Form.Item>
      </Form>
    </div>
  );
};
